/**
 * Toast Provider
 * Renders all active toasts in a fixed container
 * Place this component once at the root of your app
 */

import { useToastStore } from './toastStore';
import { Toast } from './Toast';

export function ToastProvider() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-9999 flex flex-col gap-3 pointer-events-none"
      aria-label="Notifications"
    >
      {toasts.map((t) => (
        <div key={t.id} className="pointer-events-auto">
          <Toast {...t} />
        </div>
      ))}
    </div>
  );
}

export default ToastProvider;
